/**
 * it provides mapping for canadian provinces
 */
export const CANADIAN_PROVINCES_MAPPING = [
  { name: 'Alberta', abbreviation: 'AB' },
  { name: 'British Columbia', abbreviation: 'BC' },
  { name: 'Manitoba', abbreviation: 'MB' },
  { name: 'New Brunswick', abbreviation: 'NB' },
  { name: 'Newfoundland and Labrador', abbreviation: 'NL' },
  { name: 'Northwest Territories', abbreviation: 'NT' },
  { name: 'Nova Scotia', abbreviation: 'NS' },
  { name: 'Nunavut', abbreviation: 'NU' },
  { name: 'Ontario', abbreviation: 'ON' },
  { name: 'Prince Edward Island', abbreviation: 'PE' },
  { name: 'Quebec', abbreviation: 'QC' },
  { name: 'Saskatchewan', abbreviation: 'SK' },
  { name: 'Yukon Territory', abbreviation: 'YT' }
];

/**
 * constant added for feature: hiding easy payments for TSB based on province
 */
export const shouldHideEasyPayments = 'shouldHideEasyPayments';
/**
 * constant added for feature: should send order information to ADT Dashboard for TSB based on province
 */
export const shouldSendDataToAdtDashboard = 'shouldSendDataToAdtDashboard';
